var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 412,
    height: 240,
    viewBox: "0 0 412 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 412,
    height: 240,
    fill: "var(--card-thumbnail-bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3418_1468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.667 80H139.333V173.333C139.333 180.667 145.333 186.667 152.667 186.667H246V173.333H152.667V80Z",
    fill: "var(--card-thumbnail-fg)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.333 53.3335H179.333C172 53.3335 166 59.3335 166 66.6668V146.667C166 154 172 160 179.333 160H259.333C266.667 160 272.667 154 272.667 146.667V66.6668C272.667 59.3335 266.667 53.3335 259.333 53.3335ZM259.333 120L242.667 110L226 120V66.6668H259.333V120Z",
    fill: "var(--card-thumbnail-fg)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3418_1468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "var(--card-thumbnail-fg)",
    transform: "translate(126 40)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollection);
export default __webpack_public_path__ + "static/media/collection.a32f7337a81da4cbd5ae4ce66e9873f8.svg";
export { ForwardRef as ReactComponent };